module.exports = __webpack_public_path__ + "photo4.png?3be6f763726159b53b68c8d00f4d450d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/photo4.png
// module id = 56
// module chunks = 0